export default "__VITE_ASSET__DxrAVtqs__"